import { render, staticRenderFns } from "./customer-flow.vue?vue&type=template&id=431a66c3&scoped=true&"
import script from "./customer-flow.vue?vue&type=script&lang=js&"
export * from "./customer-flow.vue?vue&type=script&lang=js&"
import style0 from "./customer-flow.vue?vue&type=style&index=0&id=431a66c3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "431a66c3",
  null
  
)

export default component.exports